import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-38">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-39">
        <img src="https://cdn.magicpatterns.com/uploads/jDnDM2SkXUvPXmFXVwb7kD/Imagen_referencia_5.png" alt="Bosque mágico y abundante" className="w-full h-full object-cover object-center" data-id="element-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FDFBF7]/90 via-[#FDFBF7]/80 to-[#FDFBF7] backdrop-blur-[2px]" data-id="element-41"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 py-20 text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-43">
          <span className="inline-block py-1 px-4 rounded-full border border-[#C5A059]/30 bg-[#C5A059]/10 text-[#A8823A] text-sm font-bold tracking-wider uppercase mb-6" data-id="element-44">
            El Código Invisible del Dinero
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-stone-900 mb-6 leading-tight font-serif" data-id="element-45">
            No es que no puedas generar dinero…{' '}
            <br className="hidden md:block" data-id="element-46" />
            <span className="gold-text-gradient italic font-normal" data-id="element-47">
              es que estás operando con un patrón invisible que lo bloquea.
            </span>
          </h1>

          <p className="text-xl text-stone-700 mb-8 max-w-2xl mx-auto" data-id="element-48">
            Y lo más inquietante…{' '}
            <strong className="font-semibold" data-id="element-49">
              es que ese patrón no se cambia trabajando más.
            </strong>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white/60 backdrop-blur-md border border-white/40 p-8 rounded-2xl shadow-xl max-w-3xl mx-auto mb-10 text-left" data-id="element-50">
          <p className="text-stone-600 text-lg leading-relaxed mb-4" data-id="element-51">
            Durante años, fuiste programada para relacionarte con el dinero
            desde el estrés, la urgencia y el miedo. Eso creó algo que casi
            nadie ve:
          </p>
          <p className="text-stone-900 text-xl font-bold mb-4 flex items-center gap-2" data-id="element-52">
            <span className="text-[#C5A059]" data-id="element-53">👉</span> Tu termostato financiero
            interno.
          </p>
          <p className="text-stone-600 text-lg leading-relaxed" data-id="element-54">
            Y ese termostato… determina cuánto dinero puedes sostener, no cuánto
            puedes ganar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex flex-col items-center justify-center mb-12" data-id="element-55">
          <p className="text-stone-800 font-serif text-xl md:text-2xl italic mb-8 max-w-3xl leading-relaxed" data-id="element-56">
            El Código Invisible del Dinero es un sistema guiado para reprogramar
            tu sistema y cambiar tu relación con el dinero desde la raíz. <br data-id="element-57" />
            <br data-id="element-58" />
            <span className="text-[#A8823A] font-medium" data-id="element-59">
              Sin fórmulas complicadas. Sin depender de suerte. Sin seguir
              agotándote.
            </span>
          </p>

          <a href="#oferta" className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-lg font-bold text-stone-900 rounded-full overflow-hidden shadow-[0_0_30px_rgba(197,160,89,0.4)] transition-all hover:shadow-[0_0_50px_rgba(197,160,89,0.6)] hover:scale-105 w-full md:w-auto" data-id="element-60">
            <div className="absolute inset-0 gold-gradient" data-id="element-61"></div>
            <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-62"></div>
            <span className="relative flex items-center gap-2 text-center" data-id="element-63">
              👉 Quiero empezar hoy
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform shrink-0" data-id="element-64" />
            </span>
          </a>
          <p className="mt-4 text-sm text-stone-500" data-id="element-65">
            Acceso inmediato. Decisión simple. Nuevo comienzo.
          </p>
        </motion.div>
      </div>
    </section>;
}